import { AccountState } from 'apprise-core/account'
import { Permissioned } from 'apprise-core/permission'
import { Lifecycle, Note, Revisioned } from 'apprise-core/common'
import { Language } from 'apprise-core/language'
import { TenantResource } from 'apprise-core/tenant'



export type UserLifecycleState = "active" | "inactive"

export type UserLifecycle = Lifecycle<UserLifecycleState> & Partial<{
  lastSession: number
}>

export type UserDetails = {
  firstname: string
  lastname: string
  email: string
  preferences: Partial<UserPreferences>
}

export type BaseUser = TenantResource & Permissioned & {

  username: string
  details: UserDetails
  tags: string[]
  guarded: boolean
  lifecycle: UserLifecycle

}

export type User = BaseUser & Partial<Revisioned<BaseUser>>

export type UserReference = string


export type UserPreferences = Partial<{

  accountId: string,
  accountState: AccountState
  language: Language
  address: string
  phone: string
  note: Note

}> & { [key: string]: any }   // extensible by clients

export type UserRef = {

    username: string
    name: string
    tenant: string
  
}

export const unknownUserId = 'unknown'

export const userPrefix = 'U'

export const userLifecycleTopic = 'user'

